
import { Component, Vue, Prop } from "vue-property-decorator";


@Component
export default class NoMappingMessage extends Vue {
    @Prop({default: ""})
    organisationName!: string
}
